import { motion } from 'motion/react'
import { Gauge, ShieldCheck, Sparkles, Users2 } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

export const TrustSignals = () => {
  return (
    <section className="relative bg-white py-24">
      {/* Subtle texture background */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?ixlib=rb-4.0.3')] opacity-[0.02] mix-blend-soft-light"></div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 text-center"
        >
          {/*
            "Trusted by Medical Device Teams" claimed a install base that does
            not exist yet. Three teams is what there is, and saying so is a
            better signal to this audience than an unbacked plural.
          */}
          <h2 className="mb-4 text-4xl font-bold text-[#001871] md:text-5xl">
            Built for medical device teams
          </h2>
          <p className="text-xl text-gray-600">
            Early access is open to quality and regulatory teams
          </p>
        </motion.div>

        {/* Trust Metrics */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Card className="border border-gray-100 bg-white transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-6">
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 rounded-xl bg-[#001871]/5 p-4">
                    <ShieldCheck className="size-10 text-[#001871]" />
                  </div>
                  {/*
                    "MDR Ready" reads as a compliance guarantee to an audience
                    that assesses compliance. The structure claim is checkable.
                  */}
                  <h3 className="mb-2 text-xl font-semibold text-[#001871]">MEDDEV structured</h3>
                  <p className="text-sm text-gray-600">Follows the 2.7/1 Rev. 4 review structure</p>
                </div>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <Card className="border border-gray-100 bg-white transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-6">
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 rounded-xl bg-[#001871]/5 p-4">
                    <Gauge className="size-10 text-[#001871]" />
                  </div>
                  {/* 48%, not "2x": the measured figure, with its population. */}
                  <h3 className="mb-2 text-xl font-semibold text-[#001871]">48% less time</h3>
                  <p className="text-sm text-gray-600">Internal testing, three client projects</p>
                </div>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <Card className="border border-gray-100 bg-white transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-6">
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 rounded-xl bg-[#001871]/5 p-4">
                    <Users2 className="size-10 text-[#001871]" />
                  </div>
                  <h3 className="mb-2 text-xl font-semibold text-[#001871]">Three teams</h3>
                  <p className="text-sm text-gray-600">Using it on live projects</p>
                </div>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <Card className="border border-gray-100 bg-white transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-6">
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 rounded-xl bg-[#001871]/5 p-4">
                    <Sparkles className="size-10 text-[#001871]" />
                  </div>
                  <h3 className="mb-2 text-xl font-semibold text-[#001871]">Early access</h3>
                  <p className="text-sm text-gray-600">Open to a small number of teams</p>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
